require('../../modules/es6.object.is-sealed');
module.exports = require('../../modules/_core').Object.isSealed;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/is-sealed.js
// module id = 683
// module chunks = 1